import React from "react";
import AddressSection from "../../../components/AddressSection";

const Step1Address = ({ form, setForm, countries, handleChange, nextStep }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (e.target.checkValidity()) {
      nextStep();
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <fieldset className="border p-3 mb-4">
        <legend>Personal & Address Information</legend>

        {/* ✅ Date of Birth Section */}
        <div className="row mb-4">
          <div className="col-md-4">
            <label>
              Date of Birth <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="dob"
              value={form.dob || ""}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  dob: e.target.value,
                }))
              }
              required
            />
          </div>
        </div>

        {/* ✅ Address 1 */}
        <div className="row mb-3">
          <div className="col-12">
            <label>
              Address 1 <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="address1"
              value={form.address1}
              onChange={handleChange}
              placeholder="Address 1"
              required
            />
          </div>
        </div>

        {/* ✅ Address 2 */}
        <div className="row mb-3">
          <div className="col-12">
            <label>Address 2</label>
            <input
              type="text"
              className="form-control"
              name="address2"
              value={form.address2}
              onChange={handleChange}
              placeholder="Address 2"
            />
          </div>
        </div>

        {/* ✅ Country, Province, City, Postal */}
        <AddressSection form={form} setForm={setForm} countries={countries} />

        {/* ✅ Next Button */}
        <div className="d-flex justify-content-end">
          <button type="submit" className="btn btn-primary">
            Next →
          </button>
        </div>
      </fieldset>
    </form>
  );
};

export default Step1Address;
